export default {
  common: {
    cancel: 'Cancel',
    remove: 'Remove',
    save: 'Execute_Commit',
    saving: 'Saving...',
    loading: 'Loading...',
    km: 'KM',
    m: 'M',
    units: 'units',
    status: 'Status',
    nominal: 'Nominal',
    alert: 'Alert',
    operational: 'Operational',
    time_stamp: 'Time_Stamp',
    fleet_size: 'Fleet_Size',
    log_v: 'Log_V',
    status_ready: 'STATUS: READY_FOR_ENTRY',
  },

  nav: {
    dashboard: 'Dashboard',
    garage: 'Garage',
    add_bike: 'Add Bike',
    rides: 'Rides',
    prepare_ride: 'Prepare a Ride',
    maintenance: 'Maintenance',
    stock: 'Stock',
    logout: 'Logout',
    service: 'Service',
    feedback: 'Feedback',
  },

  header: {
    dashboard: 'Overview',
    garage: 'Garage Overview',
    add_bike: 'Register New Bike',
    bike_detail: 'Bike Detail',
    rides: 'Ride Log',
    add_ride: 'Log New Ride',
    prepare_ride: 'GPX Analysis',
    maintenance: 'Maintenance Log',
    add_maintenance: 'Log Service Entry',
    stock: 'Component Stock',
    profile_settings: 'Profile & Settings',
    system_label: 'System',
    system_optimal: 'Optimal',
    system_degraded: 'Degraded',
    system_unreachable: '...',
    system_loading: '...',
  },

  confirm: {
    remove_bike_title: 'Remove Bike',
    remove_bike_msg: 'This bike and all its data will be permanently removed.',
    remove_component_title: 'Remove Component',
    remove_component_msg: 'This component and its wear data will be permanently removed.',
    remove_ride_title: 'Remove Ride',
    remove_ride_msg: 'This ride entry will be permanently removed.',
    remove_entry_title: 'Remove Entry',
    remove_entry_msg: 'This service entry will be permanently removed.',
    unassign_component_title: 'Send to Stock',
    unassign_component_msg: 'This component will be unassigned from the bike and moved to your stock.',
    unassign: 'Send to Stock',
    confirm_action: 'Confirm Action',
    remove: 'Remove',
    cancel: 'Cancel',
  },

  dashboard: {
    loading: 'Loading dashboard...',
    loading_critical: 'Loading alerts...',
    fleet_health: 'Fleet Health',
    bikes_count: 'Bikes',
    critical_alerts: 'Critical Alerts',
    in_stock: 'In Stock',
    critical_components: 'Critical Components',
    no_critical: 'All Clear',
    replace_btn: 'Replace',
    last_rides: 'Recent Rides',
    no_rides: 'No rides logged',
    last_maintenance: 'Recent Maintenance',
    no_maintenance: 'No maintenance logged',
    quick_actions: 'Quick Actions',
    action_add_ride: 'Log a Ride',
    action_prepare_ride: 'Prepare a Ride',
    action_prepare_ride_hint: 'GPX · Weather · Gear',
    action_add_maintenance: 'Log Maintenance',
    view_all: 'View All',
    rides_year_title: 'Rides — Current Year',
    rides_year_km: 'Distance',
    rides_year_count: 'Rides',
    rides_year_avg_speed: 'Avg Speed',
    rides_year_elevation: 'Elevation',
    rides_year_empty: 'No rides logged this year',
    next_planned_rides: 'Upcoming Rides',
    no_planned_rides: 'No planned rides',
    planned_ride_prepare_cta: 'Plan a ride',
  },

  garage: {
    fleet_total: 'Fleet Total',
    cumulative_dist: 'Cumulative Dist',
    pending_service: 'Pending Service',
    alerts: 'Alert(s)',
    clear: 'Clear',
    loading: 'Loading bikes...',
    register_bike: 'Register New Bike',
    init_config: 'Initialize System Configuration',
    error_prefix: '',
    remove_bike_title: 'Remove Bike',
    remove_bike_msg: 'This bike and all its data will be permanently removed.',
    welcome_title: 'WELCOME TO KMZ',
    welcome_subtitle: 'Init // First Configuration',
    welcome_description: 'Manage your bikes, track component wear, and prepare your rides.',
    step1_label: 'Add a Bike',
    step1_desc: 'Register your first bike in the system',
    step2_label: 'Configure Components',
    step2_desc: 'Chain, tires, cassette — track wear',
    step3_label: 'Log your Rides',
    step3_desc: 'Record your rides and maintenance',
    add_first_bike: 'Add my first bike',
  },

  bike_card: {
    service_due: 'Service Due',
    odometer: 'Odometer',
    critical: 'Critical',
    since: 'Since',
    service_btn: 'Service',
    details_btn: 'Details',
    remove_btn: 'Remove',
    alert_count: '{count} alert(s)',
  },

  bike_types: {
    road: 'Road_Performance',
    gravel: 'Gravel_All_Road',
    mtb: 'Mountain_Enduro',
    cyclocross: 'Cyclocross',
    city: 'City_Urban',
  },

  add_bike: {
    title: 'Add New Bike',
    subtitle: 'System Registry // Manual Input Required',
    field_name: '01_Bike_Name',
    field_manufacturer: '02_Manufacturer',
    field_model: '03_Model',
    field_odometer: '04_Init_Odometer',
    field_category: '05_Category',
    field_purchase_date: '06_Purchase_Date (optional)',
    meta_title: 'Registration Metadata',
    meta_v: 'Registry_V',
    warning: 'WARN: Ensure all technical specifications are validated against manufacturer manuals prior to submission.',
    submitting: 'Committing...',
    error: 'Failed to register bike',
    placeholder_name: 'E.G. CARBON_STEED_01',
    placeholder_brand: 'ENTER BRAND NAME',
    placeholder_model: 'MODEL DESIGNATION',
    next: 'Next',
    back: '← Back',
    step1_of_2: '01 / 02',
    step2_of_2: '02 / 02',
    step2_subtitle: 'Components // Which parts are currently on this bike?',
    step2_brand_placeholder: 'Brand (optional)',
    step2_lifespan_label: 'Lifespan',
    skip_components: 'Create without components',
    component_error: 'Bike created — some components could not be added.',
    onboarding_banner: 'Last step — add your bike to track wear and your rides.',
    onboarding_skip: 'Skip — go to dashboard',
    field_strava_gear: '07_Strava_Bike (optional)',
    strava_gear_placeholder: 'None',
    strava_link_title: 'Strava bikes to link',
    strava_link_desc: 'These Strava bikes are not yet linked to a KMZ bike. Create this bike and you will be redirected to make the association.',
    strava_link_toast: 'Bike created — now link it to a Strava bike below',
  },

  bike_detail: {
    loading: 'Loading bike data...',
    loading_components: 'Loading components...',
    not_found: 'Bike not found',
    back: '← Back to Garage',
    service_required: 'SERVICE REQUIRED',
    system_config: 'System Config // Asset Profile',
    category: 'Category',
    odometer: 'Odometer',
    since: 'Since',
    components_title: 'Components',
    active_components: 'Active Components',
    add_component: 'Add Component',
    register_component: 'Register New Component',
    no_components: 'No components registered',
    no_components_hint: 'Add your first component to start tracking wear',
    type: 'Type',
    brand_opt: 'Brand (optional)',
    install_date: 'Installation Date',
    km_at_install: 'KM at Installation',
    max_lifespan: 'Max Lifespan (optional)',
    km_suffix: 'KM',
    wear: 'Wear',
    installed: 'Installed',
    lifespan: 'Lifespan',
    remove: 'Remove',
    retire: 'Retire',
    active_badge: 'ACTIVE',
    retired_badge: 'RETIRED',
    critical_badge: 'CRITICAL',
    add_error: 'Failed to register component',
    add_error_conflict: "A '{type}' component is already active on this bike. Uninstall it first.",
    type_occupied_tooltip: 'Already installed — uninstall it first',
    meta_warning: 'WARN: Track component wear to prevent mechanical failures during rides.',
    unassign: 'To Stock',
    replace: 'Replace',
    recent_interventions: 'Recent Interventions',
    no_interventions: 'No maintenance intervention logged for this bike.',
    view_full_history: 'View full history →',
    log_intervention: 'Log an intervention →',
    strava_gear: 'Strava Gear',
    strava_not_mapped: 'Not mapped →',
  },

  rides: {
    title: 'Ride Log',
    planned_title: 'Planned Rides',
    completed_title: 'Completed Rides',
    total_rides: 'Total Rides',
    entries: 'Entries',
    distance: 'Distance',
    time: 'Time',
    loading: 'Loading rides...',
    log_ride: 'Log Ride',
    prepare_ride: 'Prepare Ride',
    no_rides: 'No rides logged yet',
    no_planned: 'No planned rides',
    first_ride: 'Log your first ride',
    date: 'Date',
    bike: 'Bike',
    duration: 'Duration',
    avg_speed: 'Avg Speed',
    elevation: 'Elev.',
    action: 'Action',
    remove: 'Remove',
    page_of: 'Page {page} / {total}',
    showing: 'Showing {from}–{to} of {count}',
    prev: 'Prev',
    next: 'Next',
    bike_ready: 'BIKE READY',
    bike_needs_maintenance: 'MAINTENANCE REQUIRED',
    mark_done: 'Mark as Done',
    marking_done: 'Saving...',
    difficulty: 'Difficulty',
    packing_list: 'Packing List',
    packing_phone: 'Phone',
    packing_tools: 'Inner tube + CO₂/pump',
    packing_glasses: 'Glasses',
    packing_rain_gear: 'Rain jacket / Windbreaker',
    packing_thermal: 'Thermal base layer',
    complete_modal_title: 'Mark as completed',
    complete_modal_duration: 'Actual duration',
    complete_modal_duration_hint: 'Leave at 0h 0m to keep the estimated duration ({estimated})',
    complete_modal_confirm: 'Confirm',
    complete_modal_cancel: 'Cancel',
    complete_error: 'Failed to mark ride as completed',
    edit: 'Edit',
    edit_modal_title: 'Edit Ride',
    edit_modal_name: 'Name',
    edit_modal_date: 'Date',
    edit_modal_duration: 'Duration',
    edit_modal_distance: 'Distance (km)',
    edit_modal_elevation: 'Elevation gain (m)',
    edit_modal_confirm: 'Save',
    edit_modal_cancel: 'Cancel',
    edit_error: 'Failed to update ride',
    name: 'Name',
    stats_title: 'Analytics — Summary & Trends',
    stats_total_km: 'Total Distance',
    stats_total_rides: 'Rides',
    stats_avg_speed: 'Avg Speed',
    stats_total_elevation: 'Total Elevation',
    stats_by_bike: 'By Bike',
    stats_monthly: 'Monthly Trend',
    stats_filter_year: 'Year',
    stats_filter_bike: 'Bike',
    stats_all_years: 'All',
    stats_all_bikes: 'All',
    stats_export_csv: 'Export CSV',
    stats_bike_col: 'Bike',
    stats_km_col: 'KM',
    stats_rides_col: 'Rides',
    stats_speed_col: 'Avg Speed',
    stats_elev_col: 'Elev.',
    stats_loading: 'Loading statistics...',
    avgHr: 'Avg HR',
    avgPower: 'Avg Power',
    importRide: 'Import ride',
    importError: 'Could not read the file. Make sure it is a valid .fit or .gpx file.',
    importConfirmTitle: 'Imported data',
    importConfirmHint: 'You can edit these details on the next page.',
    importConfirm: 'Continue',
  },

  strava: {
    connected: 'Connected',
    invalid: 'Invalid token',
    connectDescription: 'Connect Strava to automatically import your activities into your ride log.',
    connectButton: 'Connect Strava',
    tokenRevoked: 'Connection lost — Strava has revoked access.',
    invalidTokenAction: 'Reconnect Strava',
    connectionBroken: 'Strava connection broken',
    goToSettings: 'Settings →',
    lastSync: 'Last sync',
    gearMappings: 'Strava gear mappings',
    noGearMappings: 'No Strava bikes found.',
    noMapping: 'Not mapped',
    gearMappingHint: 'Map each Strava bike to a KMZ bike so km are counted correctly.',
    disconnect: 'Disconnect Strava',
    redirecting: 'Redirecting…',
    connectSuccess: 'Strava connected successfully',
    connectError: 'Failed to connect Strava ({detail})',
    sync: 'Sync Strava',
    syncing: 'Syncing…',
    syncSuccess: '{count} ride(s) imported from Strava',
    syncSuccessZero: 'No new rides since {date}.',
    syncErrorDetail: '{count} ride(s) imported, {errors} activity/activities with errors.',
    syncError: 'Strava sync failed',
    postConnectBanner: 'Strava connected. Map your Strava bikes so km count on the right bike.',
    postConnectBannerCta: 'Configure →',
    bikeColumn: 'KMZ Bike',
  },

  prepare_ride: {
    title: 'Prepare Ride',
    subtitle: 'GPX Import // Route Analysis',
    step1_title: 'Import & Parameters',
    field_bike: '01_Bike',
    field_date: '02_Planned_Date',
    field_hour: '03_Departure_Hour',
    field_gpx: '04_GPX_Trace',
    gpx_placeholder: 'SELECT .GPX FILE',
    analyze_btn: 'Analyze Route',
    analyzing: 'Analyzing...',
    step2_title: 'Route Analysis',
    field_name: 'Ride Name',
    route_card: 'Route Profile',
    weather_card: 'Weather Forecast',
    clothing_card: 'Recommended Kit',
    nutrition_card: 'Nutrition Plan',
    distance: 'Distance',
    elevation: 'Elevation Gain',
    duration: 'Est. Duration',
    difficulty: 'Difficulty',
    temperature: 'Temperature',
    wind: 'Wind',
    precipitation: 'Rain Probability',
    conditions: 'Conditions',
    calories: 'Calories',
    water: 'Water',
    gels: 'Gels',
    confirm_btn: 'Plan this Ride',
    restart_btn: '← New Analysis',
    confirming: 'Saving...',
    error_bike: 'Please select a bike',
    error_gpx: 'Please select a GPX file',
    error_date_range: 'Date must be between today and today+14 days (Open-Meteo forecast limit)',
    error_analyze: 'Failed to analyze GPX file',
    error_confirm: 'Failed to save ride',
    date_hint: 'Forecast available for 14 days',
    date_out_of_range_warning: 'Weather forecast is available until {date_max}. For a ride beyond that date, weather will not be available.',
    difficulty_easy: 'Easy',
    difficulty_moderate: 'Moderate',
    difficulty_hard: 'Hard',
    difficulty_very_hard: 'Very Hard',
    weather_clear: 'Clear',
    weather_partly_cloudy: 'Partly Cloudy',
    weather_fog: 'Fog',
    weather_rain: 'Rain',
    weather_snow: 'Snow',
    weather_showers: 'Showers',
    weather_storm: 'Thunderstorm',
    speed_note: 'Duration estimated at {speed} km/h (your avg)',
    weather_timeline_title: 'Hourly Weather',
    weather_timeline_empty: 'No hourly data available',
    map_title: 'Route Map',
    elevation_title: 'Elevation Profile',
    climbs_title: 'Detected Climbs',
    climb_category: 'Cat.',
    wind_title: 'Wind Impact',
    wind_headwind: 'Headwind',
    wind_tailwind: 'Tailwind',
    wind_crosswind: 'Crosswind',
    wind_penalty: 'Wind Penalty',
    wind_critical_zones: 'Critical zones',
    component_alerts_title: 'Component Alerts',
    component_alerts_empty: 'No critical components for this ride',
    no_alerts: 'All clear',
    nutrition_bars: 'Bars',
    nutrition_electrolytes: 'Electrolytes',
    nutrition_advice: 'Tip',
    difficulty_score: 'Score',
    difficulty_factors: 'Factors',
    factor_distance: 'Distance',
    factor_elevation: 'Elevation',
    factor_gradient: 'Gradient',
  },

  clothing: {
    feels_like: 'Feels like',
    layer_base: 'Base layer',
    layer_mid: 'Mid layer',
    layer_outer: 'Outer layer',
    layer_accessories: 'Accessories',
    layer_rain: 'Rain protection',
    layer_uv: 'UV protection',
    items_short: 'items',
  },

  add_ride: {
    title: 'Log New Ride',
    subtitle: 'Activity Log // Manual Input Required',
    field_name: '00_Name (optional)',
    field_bike: '01_Bike',
    field_date: '02_Date',
    field_distance: '03_Distance',
    field_elevation: '04_Elevation (m, optional)',
    meta_title: 'Activity Metadata',
    note: 'NOTE: Activity data is used to track component wear. Ensure distance is accurate.',
    submitting: 'Logging...',
    error_bike: 'Please select a bike',
    error_duration: 'Duration must be greater than 0',
    error_distance: 'Distance must be greater than 0',
    error_submit: 'Failed to log ride',
    select_bike: 'SELECT BIKE',
  },

  maintenance: {
    title: 'Maintenance Log',
    total_entries: 'Total Entries',
    logs: 'Logs',
    cost_ytd: 'Cost YTD',
    replacements: 'Replacements',
    parts: 'Parts',
    loading: 'Loading logs...',
    all_bikes: 'All Bikes',
    all_actions: 'All Actions',
    export_csv: 'Export CSV',
    log_service: 'Log Service',
    no_entries: 'No maintenance entries',
    first_service: 'Log your first service',
    date: 'Date',
    bike: 'Bike',
    component: 'Component',
    action: 'Action',
    notes: 'Notes',
    cost: 'Cost',
    km_at_change: 'Bike KM',
    remove: 'Remove',
    entry_singular: 'entry',
    entry_plural: 'entries',
    total_cost: 'total cost',
    page_of: 'Page {page} / {total}',
    showing: '{from}–{to} of {count}',
    prev: 'Prev',
    next: 'Next',
    actions: {
      cleaned: 'CLEANED',
      replaced: 'REPLACED',
      adjusted: 'ADJUSTED',
      updated: 'UPDATED',
      inspected: 'INSPECTED',
    },
    tab_log: 'Log',
  },

  add_maintenance: {
    title: 'Log Service Entry',
    subtitle: 'Maintenance Log // Manual Input Required',
    field_bike: '01_Bike',
    field_date: '02_Date',
    field_action: '03_Action',
    field_component: '04_Component(s)',
    field_km_at_change: '05_Bike KM at Change',
    field_cost: '06_Cost',
    field_notes: '07_Notes',
    meta_title: 'Service Metadata',
    meta_component: 'selected target(s)',
    select_bike: 'SELECT BIKE',
    select_component: 'SELECT BIKE OR COMPONENTS',
    loading_components: 'Loading components...',
    no_components: 'No active components on this bike',
    select_bike_first: 'Select a bike first',
    bike_target: 'BIKE — Full service',
    km_placeholder: 'Current bike odometer',
    note: 'NOTE: Select the bike for a full service, or specific components for precise wear tracking.',
    submitting: 'Saving...',
    error_bike: 'Please select a bike',
    error_target: 'Select at least one component or the bike',
    error_replace_one: 'For a replacement, select exactly one component (not the bike)',
    error_submit: 'Failed to log service entry',
    replace_side_effect_note: "NOTE: The 'Replaced' action with a linked component will automatically send the old component back to stock.",
  },

  replace: {
    btn: 'Replace',
    panel_title: 'Replacement',
    section_intervention: 'A — Intervention',
    section_new_component: 'B — New Component',
    field_date: '01_Date',
    field_km: '02_Bike KM',
    field_cost: '03_Cost',
    field_notes: '04_Notes (optional)',
    notes_placeholder: 'e.g. Chain worn after 2500km...',
    choice_stock: 'From Stock',
    choice_new: 'Create New',
    choice_none: 'No Replacement',
    select_stock: 'Stock Component',
    stock_placeholder: 'SELECT COMPONENT',
    in_stock: 'in stock',
    type_locked: 'type locked',
    submit_btn: 'Confirm Replacement',
    submitting: 'Saving...',
    success_toast: 'Replacement recorded successfully',
    error_submit: 'Failed to record replacement',
    error_name_required: 'Component name is required',
  },

  component_types: {
    chain: 'Chain',
    cassette: 'Cassette',
    front_tire: 'Front Tire',
    rear_tire: 'Rear Tire',
    front_wheel: 'Front Wheel',
    rear_wheel: 'Rear Wheel',
    front_disc: 'Front Disc',
    rear_disc: 'Rear Disc',
    front_brake_pad: 'Front Brake Pad',
    rear_brake_pad: 'Rear Brake Pad',
    front_derailleur: 'Front Derailleur',
    rear_derailleur: 'Rear Derailleur',
    crankset: 'Crankset',
    handlebar: 'Handlebar',
    saddle: 'Saddle',
    other: 'Other',
  },

  auth: {
    field_email: '01_Email',
    field_password: '02_Password',
    field_first_name: '01_First_Name',
    field_last_name: '02_Last_Name',
    field_password_register: '04_Password',
    field_error_first_name_required: 'First name is required',
    field_error_email_format: 'Invalid email address',
    field_error_password_min: 'Password: minimum 8 characters',
    authenticate: 'Authenticate',
    authenticating: 'Authenticating...',
    register_link: 'Register new account →',
    login_error: 'Incorrect email or password',
    create_account: 'Create account',
    creating_account: 'Creating account...',
    initialize_account: 'Initialize account',
    back_to_login: '← Back to login',
    register_error: 'Registration failed',
    error_email_taken: 'This email is already used. Try to log in instead.',
    error_weak_password: 'Password is too weak (minimum 6 characters).',
    error_email_invalid: 'This email address is not valid.',
    error_rate_limited: 'Too many attempts. Please wait a few minutes before retrying.',
    error_network: 'Cannot reach the server. Check your network connection.',
    error_generic: 'Registration failed. Please try again later.',
    error_link_expired: 'Confirmation link expired or invalid.',
    error_profile_missing: 'Profile creation failed. Please try signing in again.',
    resend_email: 'Resend email',
    resend_cooldown: 'Resend ({n}s)',
    resend_sent: 'Email resent',
    resend_error: 'Failed to resend email',
    change_email: 'Change email',
    restart_signup: 'Restart sign-up',
    forgot_password_link: 'Forgot password?',
    forgot_password_title: 'Reset Password',
    forgot_password_subtitle: 'Enter your email to receive a reset link',
    forgot_password_submit: 'Send Reset Link',
    forgot_password_submitting: 'Sending...',
    forgot_password_sent_title: 'Reset link sent',
    forgot_password_sent_body: 'Check your inbox. A password reset link has been sent to',
    forgot_password_hint: 'If you do not receive it within a few minutes, check your spam folder.',
    reset_password_title: 'New Password',
    reset_password_field_new: '01_New Password',
    reset_password_field_confirm: '02_Confirm Password',
    reset_password_submit: 'Set New Password',
    reset_password_submitting: 'Saving...',
    reset_password_success: 'Password updated. You can now log in.',
    reset_password_error_mismatch: 'Passwords do not match',
    reset_password_error: 'Failed to reset password. The link may have expired.',
    placeholder_first_name: 'FIRST',
    placeholder_last_name: 'LAST',
    placeholder_email: "operator{'@'}domain.com",
    placeholder_password: 'min. 8 characters',
    mission_status_title: 'MISSION STATUS',
    confirmation_sent_title: 'Check your inbox',
    confirmation_hint: 'Did not receive it? Check your spam folder. Confirm your email, then return here to log in.',
    mission_account_init: 'Account initialized',
    mission_email_sent: 'Confirmation email sent',
    mission_email_verify: 'Email verified',
    mission_garage_unlock: 'Garage unlocked',
    mission_pending: 'PENDING',
    mission_locked: 'LOCKED',
    mfa_challenge_title: 'Two-Factor Authentication',
    mfa_challenge_subtitle: 'Enter the 6-digit code from your authenticator app',
    mfa_code_label: '01_Authentication Code',
    mfa_code_placeholder: '000000',
    mfa_verify: 'Verify',
    mfa_verifying: 'Verifying...',
    mfa_error_invalid: 'Invalid code. Please try again.',
    mfa_error: 'Verification failed',
    callback_processing: 'Processing authentication...',
  },

  component: {
    edit_title: 'Edit Component',
    edit_btn: 'Edit',
    edit_success: 'Component updated',
    edit_error: 'Failed to update component',
    accumulated_km: 'Accumulated KM',
  },

  stock: {
    title: 'Component Stock',
    subtitle: 'Inventory // Unassigned Components',
    total: 'In Stock',
    components: 'Components',
    accumulated_km: 'Accumulated KM',
    loading: 'Loading stock...',
    no_components: 'No components in stock',
    no_components_hint: 'Uninstall a component from a bike to find it here.',
    add_btn: 'Add to Stock',
    assign_btn: 'Mount',
    remove_btn: 'Remove',
    assign_title: 'Mount on Bike',
    assign_select_placeholder: 'SELECT BIKE',
    assign_confirm: 'Mount',
    assign_confirm_loading: 'Mounting...',
    assign_cancel: 'Cancel',
    field_name: '01_Name',
    field_type: '02_Type',
    field_brand: '03_Brand',
    error_brand_required: 'Brand is required. Choose a brand or select "Other".',
    field_date: '04_Date',
    field_initial_km: '05_Initial KM',
    field_lifespan: '06_Max Lifespan (optional)',
    field_price: '07_Purchase Price (optional)',
    submitting: 'Saving...',
    error_submit: 'Failed to add component to stock',
    error_assign_conflict: 'A component of this type is already mounted on this bike. Uninstall it first from the bike detail page.',
    meta_title: 'Stock Metadata',
    note: 'NOTE: Components in stock do not accumulate wear. Wear is tracked only when mounted on a bike.',
    status_ready: 'STATUS: INVENTORY_READY',
  },

  profile: {
    title: 'Profile & Settings',
    subtitle: 'Account // Profile Management',
    section_profile: 'My Profile',
    section_security: 'Security',
    section_mfa: 'Two-Factor Authentication (2FA)',
    section_stats: 'Ride Statistics',
    section_danger: 'Danger Zone',
    stat_rides: 'Total Rides',
    stat_distance: 'Total Distance',
    stat_elevation: 'Total Elevation',
    stat_duration: 'Total Duration',
    stat_avg_speed: 'Avg Speed',
    stat_fallback_note: 'Not enough data — using default 20 km/h for ride preparation',
    field_first_name: '01_First Name',
    field_last_name: '02_Last Name',
    field_email: '03_Email',
    field_weight: '04_Weight',
    field_weight_placeholder: 'e.g. 72',
    field_weight_hint: 'Optional — used to estimate calories when planning a ride',
    field_height: '05_Height (cm)',
    field_height_placeholder: 'e.g. 178',
    field_dob: '06_Date of birth',
    field_gender: '07_Gender',
    field_ftp: '08_FTP (watts)',
    field_ftp_placeholder: 'e.g. 250',
    field_ftp_hint: 'Optional — used to personalize difficulty and nutrition',
    field_bpm_max: '09_Max HR (bpm)',
    field_bpm_max_placeholder: 'e.g. 190',
    field_bpm_max_hint: 'Optional — used for training zones',
    field_current_password: '01_Current Password',
    field_new_password: '02_New Password',
    field_confirm_password: '03_Confirm Password',
    field_delete_confirm: 'Type DELETE to confirm',
    save_profile: 'Save Profile',
    save_password: 'Change Password',
    delete_account_btn: 'Delete My Account',
    profile_saved: 'Profile updated',
    password_saved: 'Password changed',
    danger_warning: 'WARNING: Account deletion is irreversible. All your data (garage, bikes, components, rides, maintenance) will be permanently deleted.',
    error_email_conflict: 'This email is already used by another account',
    error_save: 'Failed to save',
    error_wrong_current: 'Current password is incorrect',
    error_password_mismatch: 'Passwords do not match',
    error_delete_confirm: 'Type exactly DELETE to confirm',
    error_delete: 'Failed to delete account',
    mfa_status_disabled: '2FA is currently disabled',
    mfa_status_enabled: '2FA is currently enabled',
    mfa_enable_btn: 'Enable 2FA',
    mfa_disable_btn: 'Disable 2FA',
    mfa_disabling: 'Disabling...',
    mfa_enroll_title: 'Scan QR Code',
    mfa_enroll_body: 'Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password…)',
    mfa_secret_label: 'Manual entry key',
    mfa_verify_title: 'Verify Setup',
    mfa_verify_body: 'Enter the 6-digit code from your app to confirm',
    mfa_code_label: '01_Authentication Code',
    mfa_confirm_btn: 'Confirm',
    mfa_confirming: 'Verifying...',
    mfa_enabled_toast: '2FA enabled',
    mfa_disabled_toast: '2FA disabled',
    mfa_error: 'Failed to update 2FA',
    mfa_error_invalid: 'Invalid code. Please try again.',
  },

  feedback: {
    title: 'Feedback & Support',
    subtitle: 'User Feedback // Reports & Suggestions',
    category_label: 'Category',
    category_bug: 'Bug Report',
    category_support: 'Support',
    category_suggestion: 'Suggestion',
    category_other: 'Other',
    field_subject: '01_Subject',
    field_message: '02_Message',
    subject_placeholder: 'Briefly describe your feedback...',
    message_placeholder: 'Give us all the useful details...',
    char_count: '{count} / 3000',
    submit: 'Send',
    submitting: 'Sending...',
    cancel: 'Cancel',
    success_toast: 'Thank you for your feedback!',
    error_toast: 'Failed to send feedback. Please try again.',
    min_length_hint: 'Minimum 10 characters',
  },

  onboarding: {
    profile_title: 'Cyclist profile',
    profile_subtitle: 'Tell us about your physiology so we can tailor your ride recommendations. Everything is optional — you can fill it later from settings.',
    section_body: 'Body',
    section_performance: 'Performance',
    gender_male: 'Male',
    gender_female: 'Female',
    gender_other: 'Other',
    gender_prefer_not_to_say: 'Prefer not to say',
    gender_placeholder: 'Select',
    save_and_continue: 'Save and continue',
    save_loading: 'Saving...',
    skip_for_now: 'Skip for now',
    saved_toast: 'Profile saved',
    skipped_toast: 'You can complete your profile later in settings',
    error_save: 'Failed to save your profile',
    error_age_range: 'Age must be between 10 and 120 years',
    error_dob_future: 'Date of birth must be in the past',
    error_ftp_range: 'FTP must be between 50 and 2000 watts',
    error_bpm_range: 'Max HR must be between 100 and 250 bpm',
    error_height_range: 'Height must be between 100 and 250 cm',
    error_weight_range: 'Weight must be between 1 and 300 kg',
    strava_section_title: 'Strava (optional)',
    strava_section_desc: 'Connect Strava to automatically pre-fill your weight, FTP, and gender — and to sync your bikes and import your past rides into the ride log.',
    strava_prefilled_notice: 'Profile pre-filled from Strava — review and adjust as needed.',
    strava_already_connected: 'Strava connected — profile and bikes synced.',
  },
}
